import { SelectionModel } from '@angular/cdk/collections';
import { AddDataSourceGeneric } from './datasource-generic';

export class SelectionService<Titem, Tkey> {
    private previousRow: Titem;
    isAllSelected: boolean;
    isAnySelected: boolean;

    toggleSelectAll(dataSource: AddDataSourceGeneric<Titem>, selection: SelectionModel<Tkey>, keySelector: (item: Titem) => Tkey) {
        const isAllSelected = this.allLoadedRowsSelected(dataSource, selection, keySelector);
        if (isAllSelected) {
            const keys = dataSource.getLoadedData().map((d) => keySelector(d));
            selection.deselect(...keys);
            this.isAllSelected = false;
            this.isAnySelected = false;
        } else {
            dataSource.getLoadedData().forEach((row) => selection.select(keySelector(row)));
            this.isAllSelected = true;
            this.isAnySelected = false;
        }
        this.markRow(dataSource, selection, keySelector);
    }

    updateSelection(
        row: Titem,
        shiftKey: boolean,
        dataSource: AddDataSourceGeneric<Titem>,
        selection: SelectionModel<Tkey>,
        keySelector: (item: Titem) => Tkey
    ) {
        if (!selection) {
            return;
        }
        if (shiftKey) {
            this.selectBetween(row, dataSource, selection, keySelector);
        } else {
            selection.toggle(keySelector(row));
        }
        this.previousRow = row;
        this.checkSelectionOfCheckbox(dataSource, selection, keySelector);
    }

    checkSelectionOfCheckbox(dataSource: AddDataSourceGeneric<Titem>, selection: SelectionModel<Tkey>, keySelector: (item: Titem) => Tkey) {
        if (selection) {
            this.isAllSelected = selection.hasValue() && this.allLoadedRowsSelected(dataSource, selection, keySelector);
            this.isAnySelected = selection.hasValue() && !this.allLoadedRowsSelected(dataSource, selection, keySelector);
            this.markRow(dataSource, selection, keySelector);
        }
    }

    private selectBetween(
        currentRow: Titem,
        dataSource: AddDataSourceGeneric<Titem>,
        selection: SelectionModel<Tkey>,
        keySelector: (item: Titem) => Tkey
    ) {
        const data = dataSource.getLoadedData();
        const currentIndex = data.indexOf(currentRow);
        const previousIndex = data.indexOf(this.previousRow);
        const isSelected = selection.isSelected(keySelector(currentRow));
        const reverse = currentIndex < previousIndex;
        const start = reverse ? currentIndex : previousIndex;
        const end = reverse ? previousIndex : currentIndex;
        for (let i = start; i <= end; i += 1) {
            const tKey = keySelector(data[i]);
            if (isSelected) {
                selection.deselect(tKey);
            } else {
                selection.select(tKey);
            }
        }
    }

    private markRow(dataSource: AddDataSourceGeneric<Titem>, selection: SelectionModel<Tkey>, keySelector: (item: Titem) => Tkey) {
        const data = dataSource.getLoadedData();
        for (let i = 0; i < data.length; i += 1) {
            const tKey = keySelector(data[i]);
            (<any>data[i])._isSelected = selection.isSelected(tKey);
        }
    }

    private allLoadedRowsSelected(
        dataSource: AddDataSourceGeneric<Titem>,
        selection: SelectionModel<Tkey>,
        keySelector: (item: Titem) => Tkey
    ) {
        if (!selection) {
            return false;
        }
        if (!dataSource) {
            return false;
        }
        const data = dataSource.getLoadedData();
        const keys = data.map((item) => keySelector(item));
        const selected = selection.selected.filter((key) => keys.includes(key));
        return selected.length >= data.length;
    }
}
